import * as React from 'react';
import { CssVarsProvider } from '@mui/joy/styles';
import theme from './theme'; 
import { CssBaseline } from '@mui/joy';
import { isSuperadmin } from './utils/permissions';

import MainLayout from './layout/MainLayout';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard'; 
import Login from './pages/LoginPage'; 
import Reset from './pages/ResetPassword'; 
import Utenti from './pages/user/Utenti'; 
import DettaglioUtente from './pages/user/DettaglioUtente'; 
import Mezzi from './pages/mezzi/Mezzi'; 
import DettaglioMezzi from './pages/mezzi/DettaglioMezzi'; 
import Checklist from './pages/checklist/Checklist'; 
import Order from './pages/marketplace/Order'; 
import OrderList from './pages/marketplace/OrderList'; 
import NotFound from './pages/404';
import NoPermessi from './pages/401';
import Category from './pages/category/Category';
import CategoryEdit from './pages/category/CategoryEdit';
import Convenzione from './pages/convention/Convenzione';
import Organizzazioni from './pages/organization/Organizzazioni';
import DettaglioOrg from './pages/organization/DettaglioOrg';
import NuovaOrg from './pages/organization/NuovaOrganizzazione';
import PrivateRoute from './components/PrivateRoute'; 
import ChangeLog from './pages/Changelog'; 
import PermissionRoute from './components/PermissionRoute';
import Image from './pages/photo/ImageGallery';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { OrgProvider } from './utils/OrgContext';

function App() {
  return (
    <CssVarsProvider theme={theme} defaultMode="light">
      <CssBaseline />
      <OrgProvider> {/* ✅ WRAP DELL’APP */}
        <BrowserRouter>
          <AppContent />
          <ToastContainer 
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </BrowserRouter>
      </OrgProvider>
    </CssVarsProvider>
  );
}

function AppContent() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/change-password" element={<Reset />} />
      <Route path="/changelog" element={<ChangeLog />} />
      <Route path="/401" element={<NoPermessi />} />

      <Route element={<PrivateRoute><MainLayout /></PrivateRoute>}>
        <Route path="dashboard" element={<Dashboard />} />

        <Route
          path="utenti"
          element={
            <PermissionRoute menuId={4} requiredLevel={1}>
              <Utenti />
            </PermissionRoute>
          }
        />
        <Route path="utenti/:id" element={<DettaglioUtente />} />

        <Route
          path="risorse"
          element={
            <PermissionRoute menuId={3} requiredLevel={1}>
              <Mezzi />
            </PermissionRoute>
          }
        />
        <Route path="risorse/:id" element={<DettaglioMezzi />} />

        <Route
          path="categorie"
          element={
            <PermissionRoute menuId={2} requiredLevel={1}>
              <Category />
            </PermissionRoute>
          }
        />
        <Route path="categorie/:id" element={<CategoryEdit />} />

        <Route
          path="convenzioni"
          element={
            <PermissionRoute menuId={2} requiredLevel={1}>
              <Convenzione />
            </PermissionRoute>
          }
        />

        <Route
          path="checklist"
          element={
            <PermissionRoute menuId={5} requiredLevel={1}>
              <Checklist />
            </PermissionRoute>
          }
        />

        <Route
          path="org"
          element={
            isSuperadmin() ? (
              <Organizzazioni />
            ) : (
              <NoPermessi />
            )
          }
        />
        
        <Route
          path="org/nuova"
          element={
            isSuperadmin() ? (
              <NuovaOrg />
            ) : (
              <NoPermessi />
            )
          }
        />
        <Route path="org/:id" element={<DettaglioOrg />} />
        <Route
          path="org/:id/order"
          element={
            isSuperadmin() ? (
              <Order />
            ) : (
              <NoPermessi />
            )
          }
        />
        <Route
          path="org/:id/orders"
          element={
            isSuperadmin() ? (
              <OrderList />
            ) : (
              <NoPermessi />
            )
          }
        />

        <Route path="photo" element={<Image />} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;
